import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-full" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "card w-full mtop-10 pad-l" }
const _hoisted_4 = { class: "row w-full" }
const _hoisted_5 = ["src"]

import { useI18n } from 'vue-i18n';
import { onMounted, ref } from 'vue';
import { FilterMatchMode } from '@primevue/core/api';
import Tag from 'primevue/tag';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { AdminApi, CreateUpdatePersonRequest, MedicalPersonLightResponse, MedicalPersonResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import EsManageInstitute from '@/components/modals/admin/esManageInstitute.vue';
import EsMedicalPersonForm from '@/components/form/admin/esMedicalPersonForm.vue';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import SharedService from "@/services/SharedService";
import { ApiError, SctLanguageItem } from '@/models/share.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'esMedicalPerson',
  setup(__props) {

const {t} = useI18n();
const toast = useToast();

const adminApi = new AdminApi(medServerApiConfig);

const medicalPersonList = ref<MedicalPersonLightResponse[]>([]);
const loading = ref(true);
const selectedMedicalPerson = ref(undefined);
const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
});
const openManageInstituteModal = ref<boolean>(false);
const openMedicalPersonFormModal = ref<boolean>(false);
const medicalPersonFormHeader = ref<string>(t('admin.medicalPerson.form.header.add'));
const selectedMedicalPersonToUpdate = ref<CreateUpdatePersonRequest>(null)

const getAllMedicalPersons = () => {
    adminApi.getAllMedicalPerson().then((response: MedicalPersonLightResponse[]) => {
        medicalPersonList.value = response.sort((a, b) =>
            a.name.localeCompare(b.name, SctLanguageItem.FrFr, { sensitivity: 'base' })
        );
        loading.value = false;
    }).catch(() => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t('error.DEFAULT')
        });
    });
}

const openAddForm = () => {
    selectedMedicalPerson.value = null;
    medicalPersonFormHeader.value = t('admin.medicalPerson.form.header.add');
    openMedicalPersonFormModal.value = true;
}

const openManageInstitutModal = (medicalPerson: MedicalPersonLightResponse) => {
    selectedMedicalPerson.value = medicalPerson;
    openManageInstituteModal.value = true;
}

const closeManageInstitutModal = async () => {
    getAllMedicalPersons();
    openManageInstituteModal.value = false;
    selectedMedicalPerson.value = undefined;
}

const closeMedicalPersonFormModal = async (refreshData: boolean) => {
    openMedicalPersonFormModal.value = false;

    if (refreshData) {
        getAllMedicalPersons();
    }
    selectedMedicalPersonToUpdate.value = null;
}

const clearFilter = () => {
    filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
};

/**
 * Fetches all medical persons from the backend and updates the local list.
 *
 * @function getAllMedicalPersons
 * @returns {void}
 */
const getMedicalPersonByUuid = (currentMedicalPerson: MedicalPersonLightResponse): Promise<void> => {
  return adminApi.getMedicalPersonByUuid({ personId: currentMedicalPerson.id })
    .then((response: MedicalPersonResponse) => {
      selectedMedicalPersonToUpdate.value = response;
    })
    .catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
};

const openModalUpdate = async (medicalPerson: MedicalPersonLightResponse): Promise<void> => {
    selectedMedicalPerson.value = medicalPerson;
    await getMedicalPersonByUuid(selectedMedicalPerson.value);
    medicalPersonFormHeader.value = t('admin.medicalPerson.form.header.update');
    openMedicalPersonFormModal.value = true; 
}

onMounted(async () => {
    await getAllMedicalPersons();
})

return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('admin.subMenu.medicalPerson')), 1),
      _createVNode(_component_es_button, {
        label: _unref(t)('action.add'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openAddForm())),
        "is-primary": true
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        filters: filters.value,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((filters).value = $event)),
        dataKey: "id",
        globalFilterFields: ['name'],
        loading: loading.value,
        value: medicalPersonList.value,
        stripedRows: "",
        paginator: "",
        rows: 10,
        rowsPerPageOptions: [5, 10, 20, 50],
        class: "w-full"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IconField), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputIcon), null, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(SharedService).getIcon('magnifyingglass', false, 'shareIcons'),
                      class: "img-grey"
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(InputText), {
                  modelValue: filters.value['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
                  placeholder: _unref(t)('admin.institute.search')
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(_unref(InputIcon), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_es_button_icon, {
                      icon: "xmark",
                      folder: "shareIcons",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilter())),
                      styles: "img-grey"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('admin.medicalPerson.table.empty')), 1)
        ]),
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('common.loading')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: 'name',
            header:  _unref(t)('admin.medicalPerson.table.name'),
            sortable: ""
          }, null, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: 'role',
            header:  _unref(t)('admin.medicalPerson.table.role'),
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_unref(t)(`common.personRole.${slotProps.data.role.toUpperCase()}`)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: 'active',
            header:  _unref(t)('admin.medicalPerson.table.active')
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(Tag), {
                severity: slotProps.data.active ? 'success' : 'warn',
                value: slotProps.data.active ? _unref(t)('common.status.active') : _unref(t)('common.status.unactive')
              }, null, 8, ["severity", "value"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: 'institutes',
            header:  _unref(t)('admin.medicalPerson.table.institut')
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.institutes && slotProps.data.institutes.length > 0)
                ? (_openBlock(), _createBlock(_component_es_button_icon, {
                    key: 0,
                    icon: "building-2_fill",
                    folder: "adminIcons",
                    class: "pad-l",
                    styles: "img-primary",
                    onClick: ($event: any) => (openManageInstitutModal(slotProps.data))
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_es_button_icon, {
                    key: 1,
                    icon: "building-2",
                    folder: "adminIcons",
                    class: "pad-l",
                    styles: "img-grey",
                    onClick: ($event: any) => (openManageInstitutModal(slotProps.data))
                  }, null, 8, ["onClick"]))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: 'updates',
            header:  _unref(t)('admin.medicalPerson.table.update')
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_es_button_icon, {
                icon: "pencil_fill",
                folder: "shareIcons",
                class: "pad-l",
                styles: "img-primary",
                onClick: ($event: any) => (openModalUpdate(slotProps.data))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["filters", "loading", "value"])
    ]),
    _createVNode(EsManageInstitute, {
      isOpen: openManageInstituteModal.value,
      "current-medical-person": selectedMedicalPerson.value,
      onModalClose: _cache[4] || (_cache[4] = ($event: any) => (closeManageInstitutModal()))
    }, null, 8, ["isOpen", "current-medical-person"]),
    _createVNode(EsMedicalPersonForm, {
      isOpen: openMedicalPersonFormModal.value,
      header: medicalPersonFormHeader.value,
      "current-medical-person": selectedMedicalPersonToUpdate.value,
      onModalClose: _cache[5] || (_cache[5] = ($event: any) => (closeMedicalPersonFormModal($event)))
    }, null, 8, ["isOpen", "header", "current-medical-person"])
  ], 64))
}
}

})